import { connect } from 'react-redux';
import { push } from 'connected-react-router'
import { useEffect, useState } from 'react'
import { addressForFinancialRecordsSelect } from '../../redux/selector/addressForFinancialRecordsSelector'
import {
    Header, 
    Paragraph, 
    Button,
    NavigationLinkButton,
    ErrorWithString,
    ErrorMark
} from '../../components/RegularComponents'
import ReviewForm from '../../components/ReviewForm/ReviewForm'
import TopNavigationBar from "../TopNavigationBar"
import {
    VIEW_MODE_REGULAR,
    APPLICATION_MODE_RENEW,
    VIEW_MODE_RENEWAL_PREVIEW,
    VIEW_MODE_RENEWAL_EDIT,
    VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT,
    CanadaProvinceList,
    ROUTE_PATH
} from '../../app/constants'
import { GetProviceCodeFromName, replaceUrlParams,ValidateString } from '../../app/utils';
import Navigation from '../Navigation';
import { saveBusinessLicenceApplicationData } from '../../redux/slice/businessLicenceApplicationSlice';
import { ERROR_STRING, VALIDATION_ERROR, VALIDATION_TYPE } from '../../app/errors';
import { setAgencyAddressForFinancialRecords } from '../../redux/slice/primaryAgencyApplicationSlice';

const AddressForFinancialRecords = (props) => {
    const {addressForFinancialRecords} = props
    const {applicationType, applicationMode} = props.match.params

    let address = "", city = "", postalCode = "", province = ""

    if(addressForFinancialRecords.financialRecordsLocation && 
        addressForFinancialRecords.financialRecordsLocation.street) { 
            address = addressForFinancialRecords.financialRecordsLocation.street
            city = addressForFinancialRecords.financialRecordsLocation.city
            postalCode = addressForFinancialRecords.financialRecordsLocation.postalCode
            province = addressForFinancialRecords.financialRecordsLocation.province
    }

    const [addressText, setAddressText] = useState(address)
    const [cityText, setCityText] = useState(city)
    const [postalCodeText, setPostalCodeText] = useState(postalCode)
    const [provinceCode, setProvinceCode] = useState(GetProviceCodeFromName(province))

    const [addressValidationError, setAddressValidationError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [cityValidationError, setCityValidationError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [postalCodeValidationError, setPostalCodeValidationError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [provinceValidationError, setProvinceValidationError] = useState(VALIDATION_ERROR.NO_ERROR)

    const [showValidationError, setShowValidationError] = useState(false)
    const [applicationSaveError, setApplicationSaveError] = useState(false)
    
    const [viewMode,setViewMode] = useState(props.viewMode ? 
        props.viewMode : (applicationMode === APPLICATION_MODE_RENEW ? 
            VIEW_MODE_RENEWAL_PREVIEW : VIEW_MODE_REGULAR))

    const validateData = () => { 

        const ret1 = ValidateString(addressText, VALIDATION_TYPE.STRING_NON_EMPTY)
        setAddressValidationError(ret1)

        const ret2 = ValidateString(cityText, VALIDATION_TYPE.STRING_NON_EMPTY)
        setCityValidationError(ret2)

        const ret3 = ValidateString(postalCodeText, VALIDATION_TYPE.CANADA_POSTAL_CODE)
        setPostalCodeValidationError(ret3)

        const ret4 = ValidateString(provinceCode, VALIDATION_TYPE.CANADA_PROVINCE_CODE)
        setProvinceValidationError(ret4)

        return (ret1 === VALIDATION_ERROR.NO_ERROR
            && ret2 === VALIDATION_ERROR.NO_ERROR
            && ret3 === VALIDATION_ERROR.NO_ERROR
            && ret4 === VALIDATION_ERROR.NO_ERROR)
    }

    const isAddressValid = () => { 
        if(showValidationError) {
            return addressValidationError === VALIDATION_ERROR.NO_ERROR
        }

        return true
    }

    const addressErrorString = () => { 
        if(addressValidationError !== VALIDATION_ERROR.NO_ERROR) {
            return "Enter a street address"
        }

        return null
    }

    const isCityValid = () => { 
        if(showValidationError) {
            return cityValidationError === VALIDATION_ERROR.NO_ERROR
        }

        return true
    }

    const cityErrorString = () => { 
        if(cityValidationError !== VALIDATION_ERROR.NO_ERROR) {
            return "Enter a city/town"
        }

        return null
    }

    const isPostalCodeValid = () => { 
        if(showValidationError) { 
            return postalCodeValidationError === VALIDATION_ERROR.NO_ERROR
        }

        return true
    }

    const postalCodeErrorString = () => { 
        if(postalCodeValidationError === VALIDATION_ERROR.EMPTY) {
            return "Enter a postal code"
        } else if(postalCodeValidationError === VALIDATION_ERROR.CANADA_POSTAL_CODE_INVALID) { 
            return "Enter valid postal code"
        } else if(postalCodeValidationError !== VALIDATION_ERROR.NO_ERROR) { 
            return "Enter a postal code"
        }

        return null
    }

    const isProvinceValid = () => { 
        if(showValidationError) {
            return provinceValidationError === VALIDATION_ERROR.NO_ERROR
        }

        return true
    }

    const provinceErrorString = () => { 
        if(provinceValidationError !== VALIDATION_ERROR.NO_ERROR) {
            return "Select a province"
        }

        return null
    }
    
    const onSaveAndNext = () => {
        setApplicationSaveError(false)
        
        if(!validateData()) {
            setShowValidationError(true)
            return
        }

        setShowValidationError(false)

        props.dispatch(setAgencyAddressForFinancialRecords({
            street : addressText,
            city: cityText, 
            province :  CanadaProvinceList[provinceCode],
            postalCode : postalCodeText
        }))

        props.dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
        .then((data) => {

            let nextUrl = addressForFinancialRecords.navigation.next

            // the next screen is criminal history question. Ask the question only if the criminal history data
            // not available.
            if(addressForFinancialRecords.criminalHistoryData 
                && Array.isArray(addressForFinancialRecords.criminalHistoryData) 
                && addressForFinancialRecords.criminalHistoryData.length > 0) { 
                nextUrl = ROUTE_PATH.CRIMINAL_HISTORY_DETAILS
            }
            
            if((viewMode === VIEW_MODE_RENEWAL_PREVIEW || viewMode === VIEW_MODE_RENEWAL_EDIT)
                && addressForFinancialRecords.navigation.nextRenewal) {
                nextUrl = addressForFinancialRecords.navigation.nextRenewal
            }
            props.dispatch(push(replaceUrlParams(nextUrl,applicationType, applicationMode)))
        }) 
        .catch(err => {
            setApplicationSaveError(true)
        })
    }

    const provinceOptionElements = []
    for (const key in CanadaProvinceList) {
        if (Object.hasOwnProperty.call(CanadaProvinceList, key)) {
            const element = CanadaProvinceList[key];
            provinceOptionElements.push(<option key={key} value={key}>{element}</option>)
        }
    }

    useEffect(() => {
        let address = "", city = "", postalCode = "", province = ""

        if(addressForFinancialRecords.financialRecordsLocation && 
            addressForFinancialRecords.financialRecordsLocation.street) { 
                address = addressForFinancialRecords.financialRecordsLocation.street
                city = addressForFinancialRecords.financialRecordsLocation.city
                postalCode = addressForFinancialRecords.financialRecordsLocation.postalCode
                province = addressForFinancialRecords.financialRecordsLocation.province
        }

        setAddressText(address)
        setCityText(city)
        setPostalCodeText(postalCode)
        setProvinceCode(GetProviceCodeFromName(province))
    }, [
        addressForFinancialRecords.financialRecordsLocation,
        setAddressText,
        setCityText,
        setPostalCodeText,
        setProvinceCode
    ])

    return (
        <>
            {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
            <Navigation {...props} /> }
            <div className={viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT ? "container" : ""}>
                {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
                <>
                    <TopNavigationBar {...props}/>
                    <div className="row bottomMarginMedium">
                        <div className="col-lg-8">
                            <Header 
                                id={'address-for-financial-records-header'} 
                                header={viewMode === VIEW_MODE_RENEWAL_PREVIEW ? 
                                    addressForFinancialRecords.headerRenewal :  addressForFinancialRecords.header} />
                            <Paragraph 
                                id={'address-for-financial-records-text'} 
                                text={viewMode === VIEW_MODE_RENEWAL_PREVIEW ? 
                                    addressForFinancialRecords.textRenewal : addressForFinancialRecords.text} />
                        </div>
                    </div>
                </>
                }
                <div className="row bottomMarginMedium">
                    <div className="col-lg-8">
                        {viewMode === VIEW_MODE_RENEWAL_PREVIEW &&
                            <ReviewForm data={{
                                "Street address" : addressText,
                                "City" : cityText,
                                "Province" :  CanadaProvinceList[provinceCode],
                                "Postal code" : postalCodeText
                            }} />
                        }

                        {viewMode !== VIEW_MODE_RENEWAL_PREVIEW &&
                        <fieldset className="ns-fieldset">
                            <div className={"ns-fieldset" + (!isAddressValid() ? " ns-fieldset-message-error" : "")}>
                                <label 
                                    className="ns-label"
                                    htmlFor={'address-for-financial-records-form-address-text'}
                                    id={"address-for-financial-records-form-address-label"}>
                                        {addressForFinancialRecords.addressTextHeader}
                                </label>
                                {!isAddressValid() && 
                                <span id="address-for-financial-records-form-address-error" className="ns-error-message field-validation-error">
                                    {ErrorWithString(addressErrorString())}
                                </span>}
                                <input 
                                    className={"fw-20" + (isAddressValid() ? " ns-input" : " ns-input--error")}
                                    id={"address-for-financial-records-form-address-text"}
                                    name={"address-for-financial-records-form-address-text"}
                                    autoComplete="street-address" 
                                    type={"text"} 
                                    value={addressText}
                                    onInput={(e) => {
                                        setAddressValidationError(VALIDATION_ERROR.NO_ERROR)
                                        setAddressText(e.target.value)
                                    }} 
                                    style={{width: "350px"}} />
                            </div>
                            <div className={"ns-fieldset" + (!isCityValid() ? " ns-fieldset-message-error" : "")}>
                                <label 
                                    className="ns-label"
                                    htmlFor={'address-for-financial-records-form-city-text'}
                                    id={"address-for-financial-records-form-city-label"}>
                                        {addressForFinancialRecords.cityTextHeader}
                                </label>
                                {!isCityValid() && 
                                <span id="address-for-financial-records-form-city-error" className="ns-error-message field-validation-error">
                                    {ErrorWithString(cityErrorString())}
                                </span>}
                                <input 
                                    className={"fw-20" + (isCityValid() ? " ns-input" : " ns-input--error")}
                                    id={"address-for-financial-records-form-city-text"}
                                    name={"address-for-financial-records-form-city-text"}
                                    autoComplete="address-level2" 
                                    type={"text"} 
                                    value={cityText} 
                                    onInput={(e) => {
                                        setCityValidationError(VALIDATION_ERROR.NO_ERROR)
                                        setCityText(e.target.value)
                                    }} 
                                    style={{width: "350px"}} />
                            </div>

                            <div className={"ns-fieldset" + (!isProvinceValid() ? " ns-fieldset-message-error" : "")}>
                                <label 
                                    id="address-for-financial-records-form-province-select-label"
                                    className="ns-label"
                                    htmlFor="address-for-financial-records-form-province-select-input">
                                        {addressForFinancialRecords.provinceTextHeader}
                                </label>
                                {!isProvinceValid() && 
                                <span id="address-for-financial-records-form-province-error" className="ns-error-message field-validation-error">
                                    {ErrorWithString(provinceErrorString())}
                                </span>}
                                <div className="select fw-20 inlineDisplay">
                                    <select 
                                        className={!isProvinceValid() ? "select--error" : ""}
                                        style={{width : "20em"}}
                                        id="address-for-financial-records-form-province-select-input"
                                        name="address-for-financial-records-form-province-select-input"
                                        value={provinceCode}
                                        onChange={(e) => {
                                                setProvinceValidationError(VALIDATION_ERROR.NO_ERROR)
                                                setProvinceCode(e.target.value)
                                            }}>
                                            {provinceOptionElements}
                                    </select>
                                </div>
                            </div>

                            <div className={"ns-fieldset" + (!isPostalCodeValid() ? " ns-fieldset-message-error" : "")}>
                                <label 
                                    className="ns-label"
                                    htmlFor={'address-for-financial-records-form-postalCode-text'}
                                    id={"address-for-financial-records-form-postalCode-label"}>
                                        {addressForFinancialRecords.postalCodeTextHeader}
                                </label>
                                {!isPostalCodeValid() && 
                                <span id="address-for-financial-records-form-postalCode-error" className="ns-error-message field-validation-error">
                                    {ErrorWithString(postalCodeErrorString())}
                                </span>}
                                <input 
                                    className={"fw-20" + (!isPostalCodeValid() ? " ns-input--error" : " ns-input")}
                                    id={"address-for-financial-records-form-postalCode-text"}
                                    name={"address-for-financial-records-form-postalCode-text"}
                                    autoComplete="postal-code" 
                                    type={"text"} 
                                    value={postalCodeText} 
                                    onInput={(e) => {
                                        setPostalCodeValidationError(VALIDATION_ERROR.NO_ERROR)
                                        setPostalCodeText(e.target.value)
                                    }} 
                                    style={{width: "350px"}} />
                            </div>
                        </fieldset>
                        }
                    </div>
                </div>
                {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
                <>
                    <div className="row bottomMarginMedium">
                        <div className={"col-lg-4" + (applicationSaveError ? " has-error" : "")}>
                            <Button 
                                id={"address-for-financial-records-save-next"}
                                onClick={onSaveAndNext}
                                text={"Save and next"}
                                buttonType={"regular_primary"}
                            />
                            {applicationSaveError && ErrorMark()}
                            {applicationSaveError && 
                            <div className="ns-error-message help-block topMarginNormal">
                                <span className="ns-visually-hidden">Error:</span>
                                {ERROR_STRING.APPLICATION_SAVE_ERROR}
                            </div>}
                        </div>
                        {viewMode === VIEW_MODE_RENEWAL_PREVIEW && 
                        <div className="col-lg-4">
                            <NavigationLinkButton 
                                id={"address-for-service-edit-mode-switch"}
                                text={"Update this information before continuing"}
                                onClick={() => { setViewMode(VIEW_MODE_RENEWAL_EDIT)}}
                            />
                        </div>}
                    </div>
                </>
                }
                {viewMode === VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
                <>
                    <div className="row bottomMarginMedium">
                        <div className={"col-lg-4" + (applicationSaveError ? " has-error" : "")}>
                            <Button 
                                id={"address-for-financial-records-edit-mode-save"}
                                onClick={() => {
                                    if(!validateData()) { 
                                        setShowValidationError(true)
                                        return
                                    }
                            
                                    setShowValidationError(false)
                                    
                                    props.dispatch(setAgencyAddressForFinancialRecords({
                                        street : addressText,
                                        city: cityText, 
                                        province :  CanadaProvinceList[provinceCode],
                                        postalCode : postalCodeText
                                    }))

                                    props.onEditSave()
                                }}
                                text={"Save"}
                                buttonType={"regular_primary"}
                            />
                            {applicationSaveError && ErrorMark()}
                            {applicationSaveError && 
                            <div className="ns-error-message help-block topMarginNormal">
                                <span className="ns-visually-hidden">Error:</span>
                                {ERROR_STRING.APPLICATION_SAVE_ERROR}
                            </div>}
                        </div>
                    </div>
                </>
                }
            </div>
        </>
    )
}

export default connect(addressForFinancialRecordsSelect)(AddressForFinancialRecords)
